export default __webpack_public_path__ + "static/media/aire-de-vidange-camping-car.d2bfa70f.svg";